<template>
  <div class="teen-page teen8">
    <div class="header">
      <h1>敦煌莫高窟：艺术的殿堂</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_8.png" alt="敦煌莫高窟">
        <div class="caption">敦煌莫高窟，丝绸之路上的艺术明珠</div>
      </div>

      <h2>一、 历史沿革</h2>
      <p>敦煌莫高窟始建于前秦时期，历经十六国、北魏、隋、唐、五代、宋、西夏等多个朝代的不断开凿，形成了规模宏大的石窟群。它是世界上现存规模最大、内容最丰富的佛教艺术圣地。</p>

      <h2>二、 洞窟艺术</h2>
      <p>莫高窟共有735个洞窟，保存有大量精美的壁画和雕塑。壁画内容包括佛教故事、历史事件、社会生活等，色彩鲜艳，线条流畅。雕塑则以佛像为主，造型优美，栩栩如生。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_8.png" alt="敦煌壁画">
        <div class="caption">精美的敦煌壁画，展现古代艺术的辉煌</div>
      </div>

      <h2>三、 藏经洞的发现</h2>
      <p>1900年，道士王圆箓在清理洞窟时意外发现了藏经洞，里面藏有大量的古代文献和艺术品。这些文物对研究中国古代历史、文化、宗教等具有极其重要的价值。</p>

      <h2>四、 丝绸之路的见证</h2>
      <p>敦煌位于丝绸之路的要道上，是东西方文化交流的重要枢纽。莫高窟的艺术融合了中国、印度、中亚等多种文化元素，是丝绸之路文明的集中体现。</p>

      <div class="quote-box">
        "敦煌者，吾国学术之伤心史也。" —— 陈寅恪
      </div>

      <h2>五、 保护与研究</h2>
      <p>由于自然和人为因素的影响，莫高窟的壁画和雕塑面临着损坏的威胁。中国政府和国际组织一直在积极开展保护工作，采用先进技术进行修复和研究，让这颗艺术明珠永放光彩。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen8'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #fef3e2;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #c41e3a 0%, #8b0000 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #8b0000;
  border-bottom: 2px solid #c41e3a;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #fff0e6;
  padding: 20px;
  border-left: 4px solid #c41e3a;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>